export const EASING = 'cubic-bezier(0.34, 0.02, 0.02, 1.04)';